import { render, staticRenderFns } from "./yudingName.vue?vue&type=template&id=21aa3d29&scoped=true"
import script from "./yudingName.vue?vue&type=script&lang=js"
export * from "./yudingName.vue?vue&type=script&lang=js"
import style0 from "./yudingName.vue?vue&type=style&index=0&id=21aa3d29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aa3d29",
  null
  
)

export default component.exports